(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['$state', '$timeout', '$q', 'User', 'Authority', 'JhiLanguageService', 'TabDomains', 'entity', 'UserProfile'];

    function UserManagementDialogController($state, $timeout, $q, User, Authority, JhiLanguageService, TabDomains, entity, UserProfile) {
        var vm = this;

        vm.authorities = null;
        vm.clear = clear;
        vm.languages = null;
        vm.userProfiles = [];
        vm.save = save;
        vm.user = entity;
        vm.domains = TabDomains.list();
        vm.loadProfiles = loadProfiles;
        vm.edit = false;
        vm.profilesLoading = false;

        initController();

        function initController() {
            var entityPromise = entity.$promise ? entity.$promise : $q.when(entity);

            entityPromise.then(function(user) {
                vm.user = user;

                Authority.query().$promise.then(function (authorities) {
                    vm.authorities = authorities;

                    if(vm.user.id) {
                        vm.edit=true;
                        loadProfiles(function () {
                            loadProfile();
                        });
                    }

                });
            });
        }

        function assignDefaultProfile() {
            $timeout(function() {
                if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                    vm.user.userProfile = vm.userProfiles[0];
                    syncSelectedProfile();
                }
            }, 0);
        }

        function syncSelectedProfile() {

            if(!vm.user || !vm.user.userProfile || !vm.user.userProfile.id) {
                return;
            }

            if(!vm.userProfiles || !vm.userProfiles.length) {
                return;
            }

            angular.forEach(vm.userProfiles, function(p) {
                if(p && p.id === vm.user.userProfile.id) {
                    vm.user.userProfile = p;
                }
            });
        }

        function loadProfile() {

            UserProfile.getByUserId({"id": vm.user.id}, onSuccess, onError);

            function onSuccess(data){
                if (data && angular.isString(data)) {
                    data = angular.fromJson(data);
                }

                vm.user.userProfile = data;

                $timeout(function() {
                    if(!vm.user.userProfile || !vm.user.userProfile.id) {
                        assignDefaultProfile();
                        return;
                    }
                    syncSelectedProfile();
                }, 0);
            }
            function onError(){
                assignDefaultProfile();
            }
        }

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear() {
            $state.go('user-management');
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $state.go('user-management');
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getAuthorityName(authorities) {
            if (angular.isArray(authorities)) {
                return authorities.length > 0 ? (authorities[0] && authorities[0].name ? authorities[0].name : authorities[0]) : null;
            }
            if (authorities && authorities.name) {
                return authorities.name;
            }
            return authorities;
        }

        function normalizeAuthorities(authorities) {
            if (angular.isArray(authorities)) {
                return authorities.map(function(a) {
                    return a && a.name ? a.name : a;
                });
            }
            if (authorities && authorities.name) {
                return [authorities.name];
            }
            if (authorities) {
                return [authorities];
            }
            return [];
        }

        function loadProfiles(callback) {
            var authorityName = getAuthorityName(vm.user.authorities);

            if (!authorityName) {
                vm.userProfiles = [];
                vm.profilesLoading = false;
                if (callback) {
                    callback();
                }
                return;
            }

            vm.profilesLoading = true;
            var result = UserProfile.default({"authority":authorityName});

            if(result && result.$promise) {
                result.$promise.then(function (data) {
                    vm.userProfiles = data;
                    vm.profilesLoading = false;

                    $timeout(function() {
                        if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                            vm.user.userProfile = vm.userProfiles[0];
                        }
                        syncSelectedProfile();
                    }, 0);

                    if(callback) {
                        callback();
                    }
                }, function(error) {
                    vm.profilesLoading = false;
                    vm.userProfiles = [];
                    if(callback) {
                        callback();
                    }
                });
            } else {
                vm.userProfiles = result;
                vm.profilesLoading = false;

                $timeout(function() {
                    if((!vm.user.userProfile || !vm.user.userProfile.id) && vm.userProfiles && vm.userProfiles.length === 1) {
                        vm.user.userProfile = vm.userProfiles[0];
                    }
                    syncSelectedProfile();
                }, 0);

                if(callback) {
                    callback();
                }
            }
        }

        function save() {
            vm.isSaving = true;
            vm.user.authorities = normalizeAuthorities(vm.user.authorities);
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

